import { Domain } from "@/types/domain";

export const educationDomains: Domain[] = [
  {
    symbol: "K12",
    name: "K–12 Education Systems",
    categories: "Curriculum standards and frameworks, District governance and administration, Student assessment and accountability, Teacher workforce management, Parent and community engagement",
  },
  {
    symbol: "HiEd",
    name: "Higher Education (Public & Private)",
    categories: "Academic program design and accreditation, Faculty governance and tenure systems, Research administration and funding, Student success and retention models, Technology transfer and IP management",
  },
  {
    symbol: "StEd",
    name: "State Education Systems",
    categories: "State Boards of Education policy, Statewide curriculum alignment, Funding formulas and compliance, Teacher licensure and certification, Longitudinal student data systems",
  },
  {
    symbol: "FedEd",
    name: "Federal Education Policy & Programs",
    categories: "U.S. Department of Education programs, Title I IDEA Title IX compliance, FAFSA and federal financial aid systems, National education research initiatives, Interagency workforce alignment",
  },
  {
    symbol: "WkDev",
    name: "Workforce Development & Career Pathways",
    categories: "Career and Technical Education (CTE), Apprenticeships and earn-and-learn models, Industry-recognized credentials, Reskilling and upskilling programs, Employer–education partnerships",
  },
  {
    symbol: "DigiAI",
    name: "Digital & AI-Enabled Learning",
    categories: "Learning Management Systems (LMS), AI tutoring and adaptive learning, Digital credentialing and badges, Learning analytics and insights, Cybersecurity and data privacy",
  },
  {
    symbol: "TchPD",
    name: "Teacher Preparation & Professional Development",
    categories: "Pre-service teacher education, Mentorship and induction programs, Continuing education and micro-credentials, Instructional coaching models, Educator evaluation frameworks",
  },
  {
    symbol: "EqAcc",
    name: "Equity, Access, and Inclusion",
    categories: "Special education services (IEPs 504s), Multilingual and bilingual education, Rural and underserved access models, Accessibility and assistive technologies, Culturally responsive pedagogy",
  },
  {
    symbol: "StHlt",
    name: "Student Health, Safety, and Well-being",
    categories: "Mental health and counseling services, School safety and crisis response, Social-emotional learning (SEL), Nutrition and wellness programs, Trauma-informed education",
  },
  {
    symbol: "AltLrn",
    name: "Alternative & Lifelong Learning",
    categories: "Homeschool and hybrid education models, Adult education and GED programs, Community colleges and continuing education, Informal and peer-based learning, Open educational resources (OER)",
  },
];
